import { Component } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { faCircle, faEnvelope, faInfoCircle, faMobile, faShieldAlt } from '@fortawesome/free-solid-svg-icons';
import { ActionsLayout } from '@progress/kendo-angular-dialog/common/actions-layout';
import { NexusComponent } from 'app/core/components/nexus/nexus.component';
import { UserMFASettingModel } from 'app/models/login.model';
import { NexusFormResultModel } from 'app/models/nexus-form-result.model';
import { SecurityService } from 'app/services/security.service';
import { environment } from 'environments/environment';

@Component({
  standalone: false,
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent extends NexusComponent {
  public user_mfa_setting_model: UserMFASettingModel = new UserMFASettingModel();
  public form_result: NexusFormResultModel = new NexusFormResultModel();
  public mobile_form_result: NexusFormResultModel = new NexusFormResultModel();
  public form = new UntypedFormGroup({
    mfa_enabled: this.CreateFormControl(false),
    application_id: this.CreateFormControl(environment.client_id),
    mfa_method:this.CreateFormControl('EMAIL'),
    phone:this.CreateFormControl()
  });
  public mobile_form = new UntypedFormGroup({
    mobile_phone: this.CreateRequiredFormControl()
  });

  faShield = faShieldAlt;
  faCircle = faCircle;
  faInfo = faInfoCircle;
  faPhone = faMobile;
  faEnvelope = faEnvelope;
  public mobile_dialog_mode: string ;
  public dialog_opened: boolean = false;
  isEmailActive: boolean = false;
  isSMSActive: boolean = false;
  isSMSDefault: boolean = true;
  isEmailDefault: boolean = true;
  enable_phone_input: boolean = true;
  public actions_layout: ActionsLayout = "start";

  constructor(private security_service: SecurityService) {
    super();
  }
  ngOnInit() {
    super.ngOnInit();
    this.load_settings();
    this.form.valueChanges.subscribe((form_data: any) => {
      this.PopulateModelFromForm(form_data, this.user_mfa_setting_model);
    });

  }
  load_settings() {
    this.StartSpinner();
    this.security_service.GetSecuritySettings().subscribe({
      next:(data)=>{
        this.user_mfa_setting_model= data;
        if (this.user_mfa_setting_model) {
          this.form.patchValue(this.user_mfa_setting_model);
          this.onRadioClick();
        }
        this.StopSpinner();
      },
      error:(err)=>{   this.StopSpinner();}
    })
  }
  submit() {
    this.form_result.Reset();

    this.SetFormTouched(this.form);
    if (this.form.invalid) {
      this.form_result.Incomplete();
      return;
    }

    this.StartSpinner();
    this.security_service.SaveSecuritySettings(this.user_mfa_setting_model).subscribe(
      data => {
            this.StopSpinner();
            this.form_result.Success("Saved Successfully");

      },
      error => {
        this.form_result.Error(error);
        this.StopSpinner();
      });
  }

  public onRadioClick(): void {
    if(this.user_mfa_setting_model?.mfa_method == "SMS")
    {
      this.isSMSDefault = false;
      this.isSMSActive = true;
      this.enable_phone_input = true;

      this.isEmailDefault = true;
      this.isEmailActive = false;
    }

    if(this.user_mfa_setting_model?.mfa_method == "Email")
    {
      this.isSMSDefault = true;
      this.isSMSActive = false;

      this.isEmailDefault = false;
      this.isEmailActive = true;
      this.enable_phone_input = false;
    }
  }

  save_mobile_phone(){


    this.form_result.Reset();
    this.mobile_form_result.Reset();
    this.SetFormTouched(this.form);
    if (this.mobile_form.invalid) {
      this.mobile_form_result.Incomplete();
      return;
    }
    const mobile_phone = this.mobile_form.get('mobile_phone').value;
    const model: UserMFASettingModel = {...this.user_mfa_setting_model};
    model.phone=mobile_phone;
    model.mfa_method = "SMS";

    this.StartSpinner();
    this.security_service.SaveSecurityPhone(model).subscribe(
      data => {
            this.StopSpinner();
            this.form_result.Success("Saved Successfully");
            this.security_service.RemoveDeviceToken();
            this.form.get('phone').setValue(data.phone);
            this.form.get('mfa_method').setValue(data.mfa_method);
            this.user_mfa_setting_model.phone = data.phone;
            this.onRadioClick();

            this.close_mobile_phone_dialog();
      },
      error => {
        this.mobile_form_result.Error(error);
        this.StopSpinner();
      });
  }

  open_mobile_phone_dialog(mode: string){
    this.mobile_dialog_mode=mode;
    const mobile_phone = this.form.get('phone').value;
    this.mobile_form.get('mobile_phone').setValue(mobile_phone);
    this.dialog_opened=true;
  }
   close_mobile_phone_dialog(){
    this.dialog_opened=false;
  }

  onToggleChange($event){
    if(!(this.user_mfa_setting_model?.mfa_enabled??false)){
      this.submit();
      return;
    }
    this.form_result.Reset();
  }
}
